import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import { CallCenter } from '../../domain/model/call_center';
import Handler from '@/core/domain/usecase/handler';


export interface ChangeCallCenterRepository {
  (id: number, data: object): Promise<CallCenter>
}

const changeCallCenterRepository = (axios: AxiosInstance): ChangeCallCenterRepository => async (id: number, data: object) => {
  try {
    const response: AxiosResponse = await axios.put(`/call-center/${id}`,
      data
    )
    return response.data
  } catch (err: any | AxiosError) {
    if (err.isAxiosError) {
      throw new Handler().trataErro(err)
    } else {
      throw err
    }
  }
}

export default changeCallCenterRepository

